import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect } from "react";
import { ToastAction, ToastContainer, ToastContent } from "./Toast.styles";
import { useControlled } from "@peersyst/react-hooks";
import { getAnimation } from "./utils/getAnimation";
import { Row, useTheme } from "..";
import { useGetIcon } from "./hooks/useGetIcon";
import { cx } from "@peersyst/react-utils";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Toast(_ref) {
  var message = _ref.message,
      type = _ref.type,
      action = _ref.action,
      positionProp = _ref.position,
      propOpen = _ref.open,
      onClose = _ref.onClose,
      onExited = _ref.onExited,
      animationProp = _ref.animation,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 4000 : _ref$duration,
      className = _ref.className,
      style = _ref.style;

  var _useTheme = useTheme(),
      _useTheme$theme = _useTheme.theme,
      toastAnimation = _useTheme$theme.toastAnimation,
      toastPosition = _useTheme$theme.toastPosition;

  var animation = animationProp || toastAnimation;
  var position = positionProp || toastPosition;

  var _useControlled = useControlled(true, propOpen, propOpen ? onClose : undefined),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      open = _useControlled2[0],
      setOpen = _useControlled2[1];

  var icon = useGetIcon(type);
  var hideTimeout;
  useEffect(function () {
    if (open && (!type || type !== "loading")) {
      hideTimeout = setTimeout(function () {
        return setOpen(false);
      }, duration);
      return function () {
        clearTimeout(hideTimeout);
      };
    }
  }, [open]);

  var _getAnimation = getAnimation(animation, position),
      AnimatedComponent = _getAnimation.AnimatedComponent,
      AnimatedComponentProps = _getAnimation.props;

  return /*#__PURE__*/_jsx(ToastContainer, {
    position: position,
    className: "ToastContainer",
    children: /*#__PURE__*/_jsx(AnimatedComponent, _objectSpread(_objectSpread({
      "in": open,
      duration: 200,
      onExited: onExited
    }, AnimatedComponentProps), {}, {
      children: /*#__PURE__*/_jsxs(ToastContent, {
        type: type,
        className: cx("Toast", className),
        style: style,
        elevation: 5,
        children: [/*#__PURE__*/_jsxs(Row, {
          alignItems: "center",
          gap: 10,
          children: [icon, message]
        }), /*#__PURE__*/_jsx(ToastAction, {
          children: action
        })]
      })
    }))
  });
}